import { useAxios } from '@/contexts/AxiosProvider'

export const useAssembly = () => {
  const axios = useAxios()

  const getAudioTranscription = async (audioFile: File) => {
    const formData = new FormData()
    formData.append('file', audioFile)

    const res = await axios.post('/transcription/transcriptions', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return res.data
  }

  return {
    getAudioTranscription,
  }
}
